import React from 'react';
import IGlossaryTerm from '@/components/interfaces/GlossaryTerm';
import Modal, { useModalManager } from '../../../common/Modal';
import VocabularyGameForm from './VocabularyGameForm';
import DropdownLink from './DropdownLink';

interface AddVocabularyGameButtonProps {
  allVocab?: IGlossaryTerm[];
  edit?: boolean;
  gameId?: number;
  hasVocabGame: boolean;
  lessonId?: number;
  programId?: number;
  text: string;
}

const AddVocabularyGameButton = ({
  allVocab, edit, gameId, hasVocabGame, lessonId, programId, text,
}: AddVocabularyGameButtonProps) => {
  const modalManager = useModalManager();

  return (
    <>
      <DropdownLink
        disabledText="Only one vocabulary game is allowed per lesson."
        href="#"
        icon="#"
        isDisabled={hasVocabGame}
        text={text}
        onClick={() => modalManager.open()}
      />
      <Modal
        nearlyFullScreen
        closeModal={modalManager.close}
        headerText={edit ? 'Add Vocabulary' : 'Add Vocabulary Game'}
        primaryButtonText="Save"
        {...modalManager}
      >
        <VocabularyGameForm
          allVocab={allVocab}
          edit={edit}
          gameId={gameId}
          lessonId={lessonId}
          modalManager={modalManager}
          programId={programId}
        />
      </Modal>
    </>
  );
};

export default AddVocabularyGameButton;
